export default {
  web: {
    status: {
      notFoundTitle: "Page not found",
      notFoundDescription: "The page you are looking for doesn't exist or may have been moved.",
      supportTitle: "Support",
      supportDescription: "For assistance with your account or any inquiries about our services, please contact us by email at support@linemate.io",
      goHome: "Go to Home",
      exploreTrends: "Explore Trends",
      openTrends: "Open Trends",
      contactSupport: "Contact Support",
    },
    download: {
      title: "Download Linemate",
      subtitle: "Available for iOS, Android and for the web.",
      ios: "Download for iOS",
      android: "Download for Android",
    },
    manageSubscription: {
      title: "Manage your subscription",
      web: "Manage on Web",
      ios: "Manage on iOS",
      android: "Manage on Android",
    },
    auth: {
      loginTitle: "Log in to Linemate",
      signupTitle: "Sign up for Linemate",
      noAccount: "Don't have an account?",
      alreadyHaveAccount: "Already have an account?",
      signUp: "Sign up",
      setupError: "Something went wrong setting up your account. You may be able to complete the process via the profile page.",
      usernameTooShort: "Username is too short (min. 6 characters).",
      usernameAlphaNumeric: "Username may only contain letters and numbers.",
      termsPrefix: "By continuing, you agree to Linemate's",
      termsOfService: "Terms of Service",
      privacyPolicy: "Privacy Policy.",
      oddsFormatTitle: "Odds format preferences",
      oddsFormatDescription: "Before we continue to Linemate, please set your preference for displaying odds in either American or decimal format.",
      oddsFormat: "Odds format",
      passwordReset: {
        forgotTitle: "Forgot password",
        resetTitle: "Reset password",
        instructions: "Enter the email address associated with your account and we'll send you a link to reset your password.",
        sentInstructions: "You will receive a password reset email soon. Follow the link in the email to reset your password.",
        sendInstructions: "Send reset instructions",
        resendInstructions: "Resend reset instructions",
        returnToLogin: "Return to log in",
        signupPrompt: "Don't have an account? Sign up",
        sendError: "Something went wrong while sending the password reset instructions, please try again later.",
      },
      changePassword: {
        title: "Change your password",
        subtitle: "Enter your new desired password.",
        newPassword: "New password",
        confirmNewPassword: "Confirm new password",
        passwordChanged: "Password changed",
        invalidLink: "We were unable to reset your password. The link you are using is either invalid or expired.",
        genericError: "We were unable to complete your request, please try again later or send the following code to our team and we'll look into it {{code}}",
      },
    },
    inputSelection: {
      clear: "Clear",
    },
  },
};
